import loadable from '@loadable/component';
import React from 'react';

import Spin from '../../spin/spin';

export const CodingProblemBlocklyLoadable = loadable(
    () => import(/* webpackChunkName: "coding-problem-blockly" */ './coding-problem__blockly'),
    {
        fallback: <Spin center delay />,
    }
);
